<!--学校一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">学校列表</span>
      </div>
      <div class="right">
        <Button type="primary" @click="addCompany()">新增学校</Button>
      </div>
    </div>
   <!--  <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <div>
        设备在学校场景下使用，可为该学校建立学校管理后台，达到对部门和员工进行文印成本管理与核算，对员工进行配额与使用权限管理、报表统计、作业历史记录查询等功能，结算方式也更灵活，具有预付和后付机制。点击查看
        <a
          target="_blank"
          style="font-weight: bold"
          href="https://aidprint.com/product_aidprint"
          >学校管理后台更多功能</a
        >
      </div>
    </div> -->
    <div class="filter-box">
      <div class="item_box">
        <Input
          v-model.trim="page.value1"
          placeholder="根据条件搜索"
          class="input"
          @on-enter="getData(1)"
        >
          <Select v-model="page.key1" slot="prepend" style="width: 100px">
            <Option value="old_code">学校ID</Option>
            <!-- <Option value="id">学校编号</Option> -->
            <Option value="company_name">学校名称</Option>
            <!-- <Option value="tel">管理员账号</Option> -->
          </Select>
        </Input>
        <Input
          v-model.trim="page.value2"
          placeholder="根据条件搜索"
          class="input"
          @on-enter="getData(1)"
        >
          <Select v-model="page.key2" slot="prepend" style="width: 100px">
            <Option value="contacts">联系人</Option>
            <Option value="company_tel">联系电话</Option>
            <Option value="email">邮箱</Option>
            <Option value="address">学校地址</Option>
          </Select>
        </Input>
        <Input
          v-model.trim="page.agent_name"
          placeholder="请输入合作伙伴名称"
          class="input"
          @on-enter="getData(1)"
          v-if="!user.tp"
        >
          <span slot="prepend">合作伙伴</span>
        </Input>

        <span class="subtitle">学校状态：</span>
        <Select v-model="page.is_del" style="width: 220px">
          <Option :value="2" style="text-align: center">全部</Option>
          <Option :value="0" style="text-align: center">正常</Option>
          <Option :value="1" style="text-align: center">禁用</Option>
        </Select>
      </div>

     <!--  <div class="item_box">
        <span class="subtitle">学校状态：</span>
        <Select v-model="page.is_del" style="width: 220px">
          <Option :value="2" style="text-align: center">全部</Option>
          <Option :value="0" style="text-align: center">正常</Option>
          <Option :value="1" style="text-align: center">禁用</Option>
        </Select>

        <span class="subtitle" style="margin-left: 20px">结算方式：</span>
        <Select v-model="page.pay_type" style="width: 220px">
          <Option :value="2" style="text-align: center">全部</Option>
          <Option :value="1" style="text-align: center">预付</Option>
          <Option :value="0" style="text-align: center">后付</Option>
        </Select>
      </div> -->
      <div class="bottom">
        <span
          class="btn-filter"
          @click="
            page.p = 0;
            getData(1)();
          "
          >筛选</span
        >
        <span class="btn" @click="reset">清空</span>
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <!-- <Button type="primary" style="margin: 0 5px 1px 0">导出Excel</Button> -->
          <span class="btn">导出报表</span>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
      </div>
    </div>
   <!--  <div class="bottom_left">
      <p class="tag_p">
        <span class="tag" @click="selectType('')" :class="{ active: page.type === '' }"
          >全部</span
        >
        <span class="tag" @click="selectType(0)" :class="{ active: page.type === 0 }"
          >云知印</span
        >
        <span class="tag" @click="selectType(1)" :class="{ active: page.type === 1 }"
          >智能运维</span
        >
      </p>
    </div> -->
    <!-- <div class="tags">
      <Tag
        v-for="(item, index) in searchShow"
        :key="index"
        closable
        @on-close="searchShowDel(index)"
        >{{ item }}</Tag
      >
      </div> -->
    <Table
      :columns="columns"
      :data="data"
      :loading="tableLoading"
      @on-sort-change="tableSort"
    />
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :current="page.p + 1"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
    <Modal :title="modal.title" v-model="modal.visible" width="800">
      <div class="modal_box">
        <Form ref="form" :model="modal.data" :rules="rule" :label-width="100">
          <!--  <FormItem prop="type" label="学校类型:" required>
            <RadioGroup v-model="modal.data.type">
              <Radio :label="0" :disabled="modal.data.id ? true : false">
                <span>云知印</span>
              </Radio>
              <Radio :label="1" :disabled="modal.data.id ? true : false">
                <span>智能运维</span>
              </Radio>
            </RadioGroup>
          </FormItem> -->
          <!-- <FormItem v-if="modal.data.id" label="编号:">
            <div style="width: 200px">
              <span>{{ modal.data.id }}</span>
              <span style="margin: 0 15px">创建时间:</span>
              <span>{{ $moment(modal.data.create_time) }}</span>
            </div>
            </FormItem> -->
          <FormItem label="管理账号:" style="display: none;">
            <input
              class="ivu-input ivu-input-default item"
              v-model="modal.data.tel"
              :disabled="true"
              onkeyup="value=value.replace(/[^\w\u4E00-\u9FA5]/g, '')"
            />
            <div class="des">
              学校管理员初始登录密码123456，登录地址：https://aidprint.com/
            </div>
          </FormItem>
          <FormItem prop="company_name" label="学校名称:">
            <Input
              v-model="modal.data.company_name"
              class="item"
              placeholder="请输入学校名称"
            />
          </FormItem>
          <FormItem prop="contacts" label="联系人:">
            <Input
              v-model="modal.data.contacts"
              class="item"
              placeholder="请输入联系人"
            />
          </FormItem>
          <FormItem prop="company_tel" label="联系电话:">
            <Input
              v-model="modal.data.company_tel"
              class="item"
              placeholder="请输入联系电话"
            />
          </FormItem>
          <FormItem prop="old_code" label="学校ID:">
            <Input
              v-model="modal.data.old_code"
              class="item"
              placeholder="请输入学校ID/UUID"
            />
            <p style="font-size: 12px;color:rgb(125 125 125);">请向接入的教育平台获取学校ID/UUID</p>
          </FormItem>
          <FormItem prop="mobile" label="手机号码:">
            <Input
              v-model="modal.data.mobile"
              class="item"
              placeholder="请输入手机号码"
            />
          </FormItem>
          <FormItem prop="email" label="邮箱地址:">
            <Input v-model="modal.data.email" class="item" placeholder="请输入邮箱地址" />
          </FormItem>
          <FormItem FormItem porp="al" label="学校地址:">
            <div class="item_addres">
              <al-selector
                :gutter="0"
                style="width: 360px"
                data-type="name"
                searchable
                v-model="modal.data.al"
                level="2"
              />
              <Input
                v-model="modal.data.address"
                style="width: 200px; margin-left: 10px"
                placeholder="详细地址（请勿重复填入省市区）"
              />
            </div>
          </FormItem>
          <FormItem prop="note" label="备注信息:">
            <Input v-model="modal.data.note" class="item" />
          </FormItem>
          <!-- <div v-if="modal.data.type == 0">
            <FormItem prop="pay_type" label="结算方式:">
              <Select v-model="modal.data.pay_type" class="item" placeholder="请选择">
                <Option :value="0">后付</Option>
                <Option :value="1">预付</Option>
              </Select>
              <div class="des">后付学校先消费后通过报表与服务商结算，预付学校需要预先充值才能消费</div>
            </FormItem>
            <FormItem prop="quota_date" label="配额日期:">
              <Select v-model="modal.data.quota_date" class="item">
                <Option v-for="i in 28" :key="i" :value="i">{{ i }}</Option>
              </Select>
              <div class="des">系统默认每月1号配额，学校可通过配额限制员工每月消费额度，额度用完账户停用，未使用完月底自动清零</div>
            </FormItem>
            <FormItem prop="scan_pay" label="扫码支付:">
              <i-switch v-model="modal.data.scan_pay" >
                <span slot="open">开</span>
                 <span slot="close">关</span>
              </i-switch>
              <div class="des">开通后，当员工账户余额不足时，可通过微信或支付宝在设备端进行扫码支付，费用将分账到设备的收款人账户</div>
            </FormItem>
            <FormItem prop="agent_id" label="合作伙伴:" v-if="!user.tp">
              <Select v-model="modal.data.agent_id" class="item" filterable placeholder="请选择">
                <Option v-for="(item, index) in agent" :key="index" :value="item.id">{{ item.id === user.id ? "自营" :
                  item.agent_name }}</Option>
              </Select>
            </FormItem>
          </div> -->
        </Form>
      </div>
      <div slot="footer">
        <Button type="text" @click="modal.visible = false">取消</Button>
        <Button type="primary" v-preventReClick :loading="loading" @click="submit"
          >确定</Button
        >
      </div>
    </Modal>
    <Modal v-model="modalPay.visible" :width="600" title="学校充值">
      <Form :label-width="100">
        <FormItem label="学校名称:">
          <span style="margin-right: 5px; color: #000000">{{
            modalPay.company_name
          }}</span>
        </FormItem>
        <FormItem label="充值金额:">
          <InputNumber
            :active-change="false"
            style="width: 200px; margin-right: 5px"
            :min="0.01"
            :precision="2"
            v-model="modalPay.data.money"
            placeholder="充值金额"
          ></InputNumber>
        </FormItem>
        <FormItem label="备注说明:">
          <Input
            v-model="modalPay.data.log"
            style="width: 200px"
            placeholder="输入备注说明"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalPay.visible = false">取消</Button>
        <Button type="primary" v-preventReClick @click="recharge">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";
export default {
  data() {
    this.searchItem = [
      { cond: "id", title: "编号", width: 100 },
      { cond: "agent_name", title: "所属", width: 200 },
      { cond: "company_name", title: "名称", width: 2000 },
      { cond: "tel", title: "账号" },
      { cond: "company_money", title: "余额" },
      { cond: "contacts", title: "联系人" },
      { cond: "company_tel", title: "电话" },
      { cond: "email", title: "邮箱" },
      {
        cond: "is_del",
        title: "状态",
        select: [
          { title: "禁用", val: 1 },
          { title: "正常", val: 0 },
        ],
      },
      {
        cond: "pay_type",
        title: "结算方式",
        select: [
          { title: "预付", val: 1 },
          { title: "后付", val: 0 },
        ],
      },
      { cond: "province", title: "省" },
      { cond: "city", title: "市" },
      { cond: "area", title: "区" },
    ];
    return {
      page: {
        p: 0,
        limit: 10,
        key1: "old_code",
        value1: "",
        key2: "contacts",
        value2: "",
        agent_name: "",
        is_del: 0, //状态
        pay_type: 2,
        senior: "",

        cond: "",
        order: "desc",
        type: "", //类型
      },
      searchList: [],
      total: 0,
      agent: [],
      modalPay: {
        visible: false,
        company_name: "",
        data: {
          company_id: 0,
          money: 0,
          log: "",
        },
      },
      modal: {
        visible: false,
        title: "新增学校",
        data: {
          id: 0,
          type: 0,
          company_name: "",
          tel: "",
          contacts: "",
          company_tel: "",
          mobile: "",
          email: "",
          pay_type:2,
          quota_date: 1,
          agent_id: "",
          al: [],
          address: "",
          note: "",
          old_code: "", //学校id
        },
      },
      rule: {
        tel: [{ required: true, message: "请输入公司登录账号", trigger: "blur" }],
        company_name: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        // contacts: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        /* company_tel: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入电话"));
                return false;
              }
              // if (value.length !== 11) {
              //   callback(new Error("请输入正确的手机号码"));
              //   return false;
              // }
              callback();
            },
            required: true,
            trigger: "blur",
          },
        ], */
        old_code: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入学校ID"));
                return false;
              }
              // if (value.length !== 11) {
              //   callback(new Error("请输入正确的手机号码"));
              //   return false;
              // }
              callback();
            },
            required: true,
            trigger: "blur",
          },
        ],
        /* pay_type: [
          {
            required: true,
            message: "请选择支付类型",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请选择支付类型"));
                return false;
              }
              callback();
            },
          },
        ], */
        agent_id: [
          {
            required: true,
            message: "请选择合作伙伴",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择合作伙伴"));
                return false;
              }
              callback();
            },
          },
        ],
        // email: [
        //   {
        //     validator: (rule, value, callback) => {
        //       var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        //       if (filter.test(value)) {
        //         callback();
        //       } else {
        //         callback(new Error("请输入正确的邮箱地址"));
        //       }
        //     },
        //     required: true,
        //     trigger: "blur",
        //   },
        // ],
      },
      data: [],
      tableLoading: false,
      loading: false,
      columns: [],
      start: [
        {
          title: "编号",
          width: 90,
          sortable: "custom",
          key: "id",
          _sortKey: "id",
          fixed: "left",
          show: true,
        },
      ],
      end: [
        {
          title: "操作",
          width: 130,
          key: "operator",
          fixed: "right",
          render: (h, data) => {
            let temp = [
              h(
                "Button",
                {
                  props: {
                    type: `${data.row.is_del ? "success" : "error"}`,
                    size: "small",
                  },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `${data.row.is_del ? "启用学校" : "禁用学校"}`,
                        content: `是否${data.row.is_del ? "启用" : "禁用"}该学校`,
                        loading: this.loading,
                        onOk: () => {
                          let temp = JSON.parse(JSON.stringify(data.row));
                          this.loading = true;
                          delete temp.create_time;
                          delete temp.agent_name;
                          delete temp._index;
                          delete temp._rowKey;
                          temp.is_del = temp.is_del ? 0 : 1;
                          console.log(156, temp, {
                            user_company: {
                              id: temp.id,
                              is_del: temp.is_del,
                              name: temp.name,
                            },
                          });
                          this.updateCompany({
                            user_company: {
                              id: temp.id,
                              is_del: temp.is_del,
                              name: temp.name,
                            },
                          }).then((res) => {
                            data.row.is_del = temp.is_del;
                            this.loading = false;
                          });
                        },
                      });
                    },
                  },
                },
                `${data.row.is_del ? "启用" : "禁用"}`
              ),
            ];

            /* temp.push(
              h(
                "Button",
                {
                  props: { type: "warning", size: "small" },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: "重置密码",
                        content: `<p>是否重置${data.row.company_name}密码为: 123456</p>`,
                        onOk: () => {
                          this.InitPWD({ id: data.row.user_id }).then(() => {
                            this.$Message.success("重置成功");
                          });
                        },
                      });
                    },
                  },
                },
                "重置密码"
              )
            ); */
            /* if (!data.row.type) {
              temp.push(
                h(
                  "Button",
                  {
                    props: { type: "success", size: "small" },
                    style: { marginRight: "5px" },
                    on: {
                      click: () => {
                        // this.$router.push({
                        //   name: "company-recharge",
                        //   query: { id: data.row.id },
                        // });
                        this.modalPay = {
                          visible: true,
                          company_name: data.row.name,
                          data: {
                            company_id: data.row.id,
                            money: 0,
                            log: "",
                          },
                        };
                      },
                    },
                  },
                  "充值"
                )
              );
            } */
            temp.push(
              h(
                "Button",
                {
                  props: { type: "warning", size: "small" },
                  on: {
                    click: () => {
                      // this.$router.push({
                      //   name: "company-edit",
                      //   params: { c_id: data.row.id },
                      // });
                      this.addCompany(data.row);
                    },
                  },
                },
                "编辑"
              )
            );
            return h("div", { style: { textAlign: "right" } }, temp);
          },
        },
      ],
      col: [
        {
          title: "名称",
          key: "company_name",
          _sortKey: "company_name",
          fixed: "left",
          minWidth: 160,
          sortable: "custom",
          show: true,
        },
        {
          title: "所属",
          width: 160,
          sortable: "custom",
          key: "agent_name",
          _sortKey: "user_agent.name",
          show: true,
          render: (h, data) => {
            return h("span", {}, data.row.agent_id ? data.row.agent_name : "运营商");
          },
        },
        {
          title: "学校ID",
          width: 360,
          sortable: "custom",
          key: "old_code",
          show: true,
        },
        /* {
          title: "学校管理员账号",
          key: "tel",
          _sortKey: "tel",
          minWidth: 160,
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {
                style: {
                  color: "#000000",
                  fontWeight: "bold",
                },
              },
              data.row.tel
            );
          },
        }, */
        /* {
          title: "结算方式",
          key: "pay_type",
          _sortKey: "pay_type",
          minWidth: 110,
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.type ? "-" : data.row.pay_type ? "预付" : "后付"
            );
          },
        }, */
        /* {
          title: "学校余额",
          key: "company_money",
          _sortKey: "company_money",
          minWidth: 120,
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h("span", data.row.type ? "-" : data.row.company_money);
          },
        }, */
        {
          title: "联系人",
          key: "contacts",
          _sortKey: "contacts",
          minWidth: 110,
          show: true,
        },
        {
          title: "电话",
          key: "company_tel",
          _sortKey: "company_tel",
          minWidth: 110,
          sortable: "custom",
          show: true,
        },
        {
          title: "邮箱",
          key: "email",
          _sortKey: "email",
          minWidth: 100,
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h("TextTooltip", {
              props: { val: data.row.email || "暂无", len: 8 },
            });
          },
        },
        {
          title: "状态",
          key: "is_del",
          _sortKey: "is_del",
          minWidth: 100,
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              { style: { color: data.row.is_del ? "#ed4014" : "#19be6b" } },
              data.row.is_del ? "禁用" : "正常"
            );
          },
        },
        {
          title: "功能详情",
          key: "functions",
          _sortKey: "functions",
          minWidth: 110,
          sortable: "custom",
          show: true,
        },
        {
          title: "地区",
          key: "address",
          _sortKey: "province",
          minWidth: 160,
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {},
              `${
                data.row.province && data.row.city && data.row.area
                  ? `${data.row.province}-${data.row.city}-${data.row.area}`
                  : "未设"
              }`
            );
          },
        },
        {
          title: "备注",
          key: "note",
          _sortKey: "note",
          minWidth: 120,
          show: true,
          tooltip: true,
        },
      ],
    };
  },
  mounted() {
    this.getData();
    this.formatCol();

    if (!this.user.tp) {
      //运营商获取合作伙伴
      this.getAgentList({ p: 0, l: 1000, is_del: 0 }).then((res) => {
        this.agent = res.data;
      });
    }
  },
  methods: {
    // 删除显示在外部的条件
    searchShowDel(index) {
      let temp = this.page.senior.split("|||");
      temp.splice(index, 1);
      this.searchList.splice(index, 1);
      this.searchShow.splice(index, 1);
      this.page.senior = temp.join("|||");
      this.getData();
    },
    // 导出excel 是否导出全部
    exportData(is_all) {
      let title = ["编号"],
        key = ["id"];
      this.col.map((item) => {
        if (item.show) {
          title.push(item.title);
          key.push(item.key);
        }
      });
      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: "学校列表",
      };
      if (is_all) {
        let page = JSON.parse(JSON.stringify(this.page));
        page.l = this.total;
        page.p = 0;
        this.getCompany(page).then((res) => {
          params.data = this.excelData(res.data);
          excel.export_array_to_excel(params);
        });
      } else {
        params.data = this.excelData(this.data);
        excel.export_array_to_excel(params);
      }
    },
    // 导出格式化数据
    excelData(data) {
      let result = JSON.parse(JSON.stringify(data));
      result.map((item) => {
        item.is_del = item.is_del ? "禁用" : "正常";
        item.pay_type = item.pay_type ? "预付" : "后付";
        item.address = item.province ? `${item.province}-${item.city}-${item.area}` : "";
      });
      return result;
    },
    // 表格排序变化
    tableSort(col) {
      this.page.key = col.column._sortKey;
      this.page.order = col.order;
      this.getData();
    },
    reset() {
      this.page = {
        p: 0,
        limit: 10,
        key1: "old_code",
        value: "",
        key2: "contacts",
        value2: "",
        cond: "",
        is_del: 0, // 禁用列表
        pay_type: 2,
        order: "desc",
        type: "", //类型
      };
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    getData(filter) {
      this.page.senior = "";
      let temp = [];

      if (this.page.type) {
        temp.push(`type***0***${this.page.type}`);
      }
      if (this.page.value1) {
        temp.push(`${this.page.key1}***1***${this.page.value1}`);
      }
      if (this.page.value2) {
        temp.push(`${this.page.key2}***1***${this.page.value2}`);
      }
      if (this.page.agent_name) {
        temp.push(`agent_name***1***${this.page.agent_name}`);
      }
      if (this.page.is_del !== 2) {
        temp.push(`is_del***0***${this.page.is_del}`);
      } else {
        temp.push(`is_del***2***${this.page.is_del}`);
      }
      if (this.page.pay_type !== 2) {
        temp.push(`pay_type***0***${this.page.pay_type}`);
      } else {
        temp.push(`pay_type***2***${this.page.pay_type}`);
      }
      if (temp.length > 0) {
        this.page.senior = temp.join("|||");
      }
      this.tableLoading = true;
      let data = JSON.parse(JSON.stringify(this.page));
      if (data.is_del === 2) {
        delete data.is_del;
      }
      if (data.pay_type == 2) {
        delete data.pay_type;
      }
      if (filter) {
        this.page.p = 0;
      }
      this.getCompany(data).then((res) => {
        this.data = res.data;
        this.total = res.total;
        this.tableLoading = false;
      });
    },
    formatCol() {
      let temp = [];
      this.col.map((item) => {
        if (item.show) {
          temp.push(item);
        }
      });
      this.columns = this.start.concat(temp).concat(this.end);
    },
    selectType(type) {
      this.page.type = type;
      this.page.p = 0;
      this.getData();
    },
    addCompany(item = null) {
      this.modal.visible = true;
      console.log("item", item);
      if (item) {
        this.modal.title = "编辑学校";
        this.infoCompany({ id: item.id }).then((res) => {
          if (res.length) {
            this.modal.data = res[0];
            this.modal.data.al = [res[0].province, res[0].city, res[0].area];
          } else {
            this.$Message.error("未找到相应学校");
          }
        });
      } else {
        this.modal.title = "新增学校";
        this.modal.data = {
          id: 0,
          type: 0,
          company_name: "",
          tel: "",
          contacts: "",
          company_tel: "",
          email: "",
          pay_type: "",
          quota_date: 1,
          agent_id: "",
          al: [],
          address: "",
          note: "",
          old_code: "",
        };
        this.getCompanyTel();
      }
    },
    getCompanyTel() {
      this.CompanyUserName({ agent_id: this.user.id }).then((res) => {
        this.modal.data.tel = res;
      });
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = this.modal.data;
          let user_company = {
            name: data.company_name,
            tel: data.company_tel,
            email: data.email,
            agent_id: data.agent_id,
            note: data.note,
            type: data.type,
            contacts: data.contacts,
            address: data.address,
            old_code: data.old_code,
          };
          if (this.user.tp) {
            user_company.agent_id = this.user.id;
          }

          if (!data.type) {
            user_company.pay_type = data.pay_type;
            user_company.quota_date = data.quota_date;
          }
          if (data.al.length > 0) {
            user_company.province = data.al[0] || "";
            user_company.city = data.al[1] || "";
            user_company.area = data.al[2] || "";
          }
          if (data.id) {
            user_company.id = data.id;
            //更新
            this.updateCompany({
              user: { id: data.user_id, tel: data.tel },
              user_company: user_company,
            }).then((res) => {
              this.loading = false;
              if (res.status) {
                this.$Message.success("保存成功");
                this.modal.visible = false;
                this.getData();
              } else {
                this.$Message.error(res.msg);
              }
            });
          } else {
            let user = {
              name: data.company_name,
              is_company: 1,
            };
            (user.tel = data.tel), (user.password = "123456");
            this.insertCompany({ user: user, user_company: user_company }).then((res) => {
              this.loading = false;
              if (res.status) {
                this.$Message.success("新增成功");
                this.modal.visible = false;
                this.getData();
              } else {
                this.$Message.error(res.log);
              }
            });
          }
        }
      });
    },
    recharge() {
      if (this.modalPay.data.money > 0) {
        this.CompanyRecharge(this.modalPay.data).then((res) => {
          if (res) {
            this.$Message.success("充值成功");
            this.modalPay = {
              visible: false,
              company_name: "",
              data: {
                company_id: 0,
                money: 0,
                log: "",
              },
            };
            this.getData();
          } else {
            this.$Message.error("充值失败");
          }
        });
      } else {
        this.$Message.error("充值金额有误");
      }
    },
    ...mapActions([
      "getCompany",
      "updateCompany",
      "InitPWD",
      "getAgentList",
      "CompanyUserName",
      "infoCompany",
      "updateCompany",
      "insertCompany",
      "CompanyRecharge",
    ]),
  },

  computed: mapGetters({
    user: "agent",
  }),
  watch: {
    col: {
      handler(n, o) {
        this.formatCol();
      },
      deep: true,
    },
    // "page.is_del"(n, o) {
    //   this.getData();
    // },
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
